// @ts-nocheck
/** Table cell: truncated error text; click opens full message when `onView` is set. */
export const TruncatedErrorCell = ({ message, subject, onView, maxWidthClass = 'max-w-[11rem]' }) => {
  if (!message) {
    return <span className="text-xs text-gray-400">—</span>;
  }

  const label = subject ? `View full error for ${subject}` : 'View full error';

  if (!onView) {
    return (
      <span className={`block min-w-0 truncate text-xs font-normal text-red-600 ${maxWidthClass}`} title={message}>
        {message}
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={onView}
      aria-label={label}
      title={label}
      className={`block min-w-0 max-w-full truncate text-left text-xs font-normal text-red-600 hover:text-red-800 hover:underline cursor-pointer ${maxWidthClass}`}
    >
      {message}
    </button>
  );
};
